var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandedRoadmapLineMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1367,
    height: 46,
    viewBox: "0 0 1367 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458 25.1713C471 12.5046 484 -14.3285 521.5 18.1715C562.379 53.5999 608.5 31.6713 608.5 20.6713C608.5 9.67128 580.5 12.1713 590 25.1713C597.6 35.5713 613.167 38.838 620 39.1713C639.833 40.0046 653.785 20.2451 677 7.74512C689.688 0.913196 705.456 1.17733 711 3.41455C719.657 6.90791 721.733 18.6261 724.5 23.7449C734.5 42.2452 742.181 38.7451 764 23.7449C788 7.24514 804.167 28.1713 813.5 33.6713C822.5 41.1713 850.6 48.0713 861 33.6713C874 15.6713 845 14.7452 849.5 29.7452C854 44.7452 866.796 45.2807 883.5 42.2452C889 41.2458 904.5 33.2452 909 29.7452",
    stroke: "url(#paint0_linear_4210_1103)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25.1713C15 12.5046 28 -14.3285 65.5 18.1715C106.379 53.5999 152.5 31.6713 152.5 20.6713C152.5 9.67128 124.5 12.1713 134 25.1713C141.6 35.5713 157.167 38.838 164 39.1713C183.833 40.0046 197.785 20.2451 221 7.74512C233.688 0.913196 249.456 1.17733 255 3.41455C263.657 6.90791 265.733 18.6261 268.5 23.7449C278.5 42.2452 286.181 38.7451 308 23.7449C332 7.24514 348.167 28.1713 357.5 33.6713C366.5 41.1713 394.6 48.0713 405 33.6713C418 15.6713 389 14.7452 393.5 29.7452C398 44.7452 410.796 45.2807 427.5 42.2452C433 41.2458 448.5 33.2452 453 29.7452",
    stroke: "url(#paint1_linear_4210_1103)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M914 25.1713C927 12.5046 940 -14.3285 977.5 18.1715C1018.38 53.5999 1064.5 31.6713 1064.5 20.6713C1064.5 9.67128 1036.5 12.1713 1046 25.1713C1053.6 35.5713 1069.17 38.838 1076 39.1713C1095.83 40.0046 1109.79 20.2451 1133 7.74512C1145.69 0.913196 1161.46 1.17733 1167 3.41455C1175.66 6.90791 1177.73 18.6261 1180.5 23.7449C1190.5 42.2452 1198.18 38.7451 1220 23.7449C1244 7.24514 1260.17 28.1713 1269.5 33.6713C1278.5 41.1713 1306.6 48.0713 1317 33.6713C1330 15.6713 1301 14.7452 1305.5 29.7452C1310 44.7452 1322.8 45.2807 1339.5 42.2452C1345 41.2458 1360.5 33.2452 1365 29.7452",
    stroke: "url(#paint2_linear_4210_1103)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "6 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4210_1103",
    x1: 1250.28,
    y1: 38.6887,
    x2: 1240.16,
    y2: -78.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0283331,
    stopColor: "#A29EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#B292D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473333,
    stopColor: "#B557AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748333,
    stopColor: "#6B3A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4210_1103",
    x1: 794.277,
    y1: 38.6887,
    x2: 784.164,
    y2: -78.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0283331,
    stopColor: "#A29EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#B292D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473333,
    stopColor: "#B557AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748333,
    stopColor: "#6B3A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2A79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4210_1103",
    x1: 1706.28,
    y1: 38.6887,
    x2: 1696.16,
    y2: -78.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0283331,
    stopColor: "#A29EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133333,
    stopColor: "#B292D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473333,
    stopColor: "#B557AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748333,
    stopColor: "#6B3A8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D2A79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandedRoadmapLineMapView);
export default __webpack_public_path__ + "static/media/Expanded Roadmap Line (Map View).1396b056eb7a2e626a09f9b0d95146ef.svg";
export { ForwardRef as ReactComponent };